import { createContext, useState } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

  const [userId, setUserId] = useState(
    localStorage.getItem("userId") || ""
  );

  const [userName, setUserName] = useState(
    localStorage.getItem("userName") || ""
  );

  const [userEmail, setUserEmail] = useState(
    localStorage.getItem("userEmail") || ""
  );

  const [userRole, setUserRole] = useState(
    localStorage.getItem("userRole") || ""
  );

  const clearAuth = () => {
    localStorage.clear();

    setUserId("");
    setUserName("");
    setUserEmail("");
    setUserRole("");
  };

  return (
    <AuthContext.Provider
      value={{
        userId,
        setUserId,
        userName,
        setUserName,
        userEmail,
        setUserEmail,
        userRole,
        setUserRole,
        clearAuth,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};